module.exports = __webpack_public_path__ + "assets/img/智骑宝详情页1920.ac769f62.png";